import { useState } from "react";
import PropTypes from "prop-types";
import PasswordIcon from "/public/images/icons/passwordEye.svg?react";
import HidePasswordIcon from "/public/images/icons/hidePassword.svg?react";
import ErrorIcon from "/public/images/icons/inputError.svg?react";
import { useThemeContext } from "../../context/themeContext";
export default function TextInput({
  name,
  onChange,
  onClick,
  type,
  required,
  readonly,
  placeholder,
  label,
  error,
  defaultValue,
  className,
  ref,
  htmlError,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const { theme } = useThemeContext();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <label className={`flex flex-col gap-1`}>
      {label && (
        <div>
          <span className="text-sportsBlack font-medium text-base leading-[26px] mb-1">
            {label}
            {required && "*"}
          </span>
        </div>
      )}

      <div className="relative">
        <input
          type={(showPassword && "text") || type || "text"}
          placeholder={placeholder}
          name={name}
          defaultValue={defaultValue}
          onChange={onChange}
          onClick={onClick}
          ref={ref}
          step={"any"}
          required={required}
          readOnly={readonly}
          {...props}
          className={`
            ${error && "border-sportsRed !border-2 pr-[42px]"}
            ${
              theme === "staff"
                ? "focus:outline-sportsBlue"
                : "focus:outline-sportsYellow"
            }
            ${className && className}
            placeholder:text-[#727272] 
            autofill:!bg-sportsLightGrey bg-sportsLightGrey w-full border-solid border-[1px] border-[#E3E3E3] rounded-[4px] p-3 text-base leading-[26px] text-[#101820]
          `}
        />

        {type === "password" && (
          <span
            onClick={togglePasswordVisibility}
            className={`${
              error ? "right-11" : "right-4"
            } absolute top-1/2 -translate-y-1/2 cursor-pointer `}
          >
            {showPassword ? (
              <HidePasswordIcon className="w-6 h-6" />
            ) : (
              <PasswordIcon className="w-6 h-6" />
            )}
          </span>
        )}

        {error && (
          <span className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer">
            <ErrorIcon className="w-6 h-6" />
          </span>
        )}
      </div>
      {error && (
        <p className="text-sportsRed text-base leading-[24px]">
          {htmlError ? (
            <span dangerouslySetInnerHTML={{__html: error}} className="[&>a]:underline"/>
          ) : error}</p>
      )}
    </label>
  );
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.string,
  required: PropTypes.bool,
  readonly: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};
